var tabs = require('mixins/tab-state');

Vue.component('home', {
    props: ['user', 'currentTeam'],

    /**
     * Load mixins for the component.
     */
    mixins: [tabs],


    /**
     * Prepare the component.
     */
    mounted() {
        this.usePushStateForTabs('.Dashboard_Nav');
    },


    /**
     * The component has been created by Vue.
     */
    // created() {
    //     Bus.$on('sparkHashChanged', function (hash, parameters) {
    //         history.pushState(null, null, `#/client-pacing`);
    //         return true;
    //     });
    // }
});



// WEBPACK FOOTER //
// ./resources/assets/js/components/home.js